import React, { useEffect, useState } from 'react';
import RemainingCredits from '../../../atoms/creditCount';
import { getApi } from '../../../../services/token';
import useStyles from './styles';
import Title from './Title';
import InputComponent from './Input';
import Chat from './chatbox';

const PAYMENT_API_URL = process.env.REACT_APP_PAYMENT_API_URL;

const DocExplorerChat = () => {
  const classes = useStyles();
  const [credit, setCredit] = useState(null);

  useEffect(() => {
    const getCreditsData = async () => {
      const { data } = await getApi(`${PAYMENT_API_URL}/user/limits`);
      const limitsData = data?.data;
      const currentCredit =
        (limitsData?.limits &&
          limitsData?.limits.length > 0 &&
          limitsData.limits.find((x) => x.type === 'QNA')?.remaining_limits) ||
        0;
      setCredit(currentCredit);
    };

    getCreditsData();
  });
  return (
    <div className={classes.mainChatGridContainer}>
      <Title title="headder.docExplorer" />
      <Chat />
      <InputComponent />
      {credit != null && <RemainingCredits credit={credit} />}
    </div>
  );
};

export default React.memo(DocExplorerChat);
